import React, { lazy, Suspense } from "react";
import { LazyLoader } from "../../../assets/loaders";
const LazyComponent = lazy(() => import("./UserDetails"));

export default function UserDetails() {
  return (
    <Suspense fallback={<LazyLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
